import React from "react";

function Header() {
  return (
    <header>
      <div className='wrapper'>
        <h1>
          <span>“</span>Quotivation
        </h1>
        <h2>Words to Fuel your Day</h2>
      </div>
    </header>
  );
}

export default Header;
